module.exports = __webpack_public_path__ + "img/picture.53a32868.svg";